import './psw_config.js';
if (!global._babelPolyfill) {
    require("babel-polyfill");
}

import Vue from 'vue';
import PageSearchWidget from './components/page-search-widget.vue';
import VMasker from './MaskedInput.js';
import Moment from 'moment';
Moment.locale('da');

Vue.directive('ui-mask', (el, binding) => {
    if (binding.value.mask) {
        VMasker(el).maskPattern(binding.value.mask);
    }
});

if(document.getElementById('page-search-widget')) {
    const VuePageSearchWidget = new Vue({
        el: '#page-search-widget',
        components: {
            PageSearchWidget
        }
    });
}